import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { getCanonicalUrl, getReciprocalAlternates } from "@/utils/routes";
import { ENTITY_GRAPH } from "@/data/entity";

/**
 * Cabecera global del sitio (fuente única de verdad).
 *
 * 1. hreflang recíprocos: `getReciprocalAlternates` (src/utils/routes.ts) es la
 *    misma función que usa el generador del sitemap. Nunca se inventa un
 *    alternate añadiendo "/en".
 * 2. Grafo de entidad único (Person / Organization / WebSite) definido en
 *    `src/data/entity.ts` y referenciado por `@id` desde el resto de páginas.
 */

const normalize = (path: string) =>
  path.length > 1 ? path.replace(/\/+$/, "") : path;

export const SiteHead = () => {
  const { pathname } = useLocation();
  const path = normalize(pathname);

  const alt = getReciprocalAlternates(path);

  return (
    <Helmet>
      {alt.es && (
        <link rel="alternate" hrefLang="es" href={getCanonicalUrl(alt.es)} />
      )}
      {alt.en && (
        <link rel="alternate" hrefLang="en" href={getCanonicalUrl(alt.en)} />
      )}
      {alt.xDefault && (
        <link
          rel="alternate"
          hrefLang="x-default"
          href={getCanonicalUrl(alt.xDefault)}
        />
      )}
      <script type="application/ld+json">{JSON.stringify(ENTITY_GRAPH)}</script>
    </Helmet>
  );
};
